/**
 * Calculator reference helpers for the report builder.
 *
 * Each carbon reference field (Site Settings > Calculator Settings) starts
 * with its own "Reference:" line, which the public calculator page needs.
 * The report builder groups them under one heading, so it removes that line.
 */

(function () {
  "use strict";

  // A leading "Reference:" / "References:" (optionally inside the first <p>)
  // plus the line break or </p> after it
  const LEADING_HEADING =
    /^(\s*<p[^>]*>)?\s*references?\s*:\s*(?:<br\s*\/?>\s*|(<\/p>)\s*)?/i;

  /**
   * Remove the "Reference:" line from the start of a field's HTML.
   */
  function stripReferenceHeading(html) {
    if (!html) return "";
    return String(html).replace(
      LEADING_HEADING,
      function (match, openParagraph, closeParagraph) {
        // Heading in its own <p>: drop it all. Otherwise keep the opening <p>,
        // which also holds the reference
        return closeParagraph ? "" : openParagraph || "";
      }
    );
  }

  /**
   * True if the HTML has text or an image to show, not just empty tags.
   */
  function hasReferenceContent(html) {
    if (!html) return false;
    if (/<img\b/i.test(html)) return true;
    const text = String(html)
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;|&#160;/gi, " ");
    return text.trim() !== "";
  }

  window.MchriCalculatorReferences = {
    stripReferenceHeading: stripReferenceHeading,
    hasReferenceContent: hasReferenceContent,
  };
})();
